export const LANGS = [
  { code: "ru", label: "RU" },
  { code: "en", label: "EN" },
  { code: "pl", label: "PL" },
];

const EVENT_TRANSLATIONS = {
  ru: {
    nav: {
      brand: "Business Conf · Варшава",
    },
    hero: {
      date_chip: "21.06",
      date_sub: "14:00 · Варшава, Польша",
      title1: "BUSINESS",
      title2: "CONFERENCE",
      desc: "Прокачай нетворкинг, личный бренд и бизнес в кругу единомышленников. Один день, который изменит траекторию вашего следующего года.",
      cta_tickets: "Выбрать билет",
      cta_program: "Программа дня",
      stat1k: "100+", stat1v: "Участников",
      stat2k: "9", stat2v: "Форматов",
      stat3k: "1", stat3v: "День, который вы запомните",
      stage_kicker: "Главная сцена",
      stage_title: "Поток инсайтов",
    },
    program: {
      eyebrow: "Что внутри",
      title: "Программа конференции",
      desc: "Девять элементов программы, выстроенных так, чтобы каждый участник вышел с реальными контактами и инсайтами.",
      items: [
        { title: "Кейноуты топ-спикеров", text: "Глубокие выступления от практиков с реальным опытом и кейсами." },
        { title: "Подарки каждому гостю", text: "Welcome-набор и сюрпризы от партнёров мероприятия." },
        { title: "Авторский нетворкинг", text: "Структурированный формат знакомств — без неловких пауз." },
        { title: "Закрытый чат-сообщество", text: "Доступ к приватному чату участников после конференции." },
        { title: "Welcome drink & finger food", text: "Лёгкий фуршет в приятной атмосфере." },
        { title: "Интерактивные воркшопы", text: "Практические сессии — забираете с собой инструменты, а не теорию." },
        { title: "Премиум фотозона", text: "Идеальные кадры для соцсетей и личного бренда." },
        { title: "Профессиональная съёмка", text: "Фото и видео-репортаж — материалы для вашего контента." },
        { title: "Afterparty", text: "Неформальный нетворкинг и игра «Мафия» с участниками." },
      ],
    },
    speakers: {
      eyebrow: "Сцена",
      title: "Спикеры",
      desc: "Шесть выступающих — практики из бизнеса, маркетинга, инвестиций и личного бренда.",
      role_label: "Тема",
      list: [
        { name: "Виктор Бартак", role: "Владелец SEO агентства №1 в B2B по версии UK Search Awards", teaser: "Получаем клиентов через SEO & AEO & GEO в 2026 году" },
        { name: "Рената Берген", role: "Стратегический советник собственников и C-level | Бизнес-психолог", teaser: "Психология стабильных денег: онлайн/офлайн" },
        { name: "Дина Завадская", role: "Маркетолог с опытом более 4 лет, владелица 2-ух онлайн бизнесов", teaser: "Система продвижения в 2026 году" },
        { name: "Юлия Ласкер", role: "Стратег личного бренда | Посол UN Red Ribbon | Обладатель награды MTV", teaser: "Ошибка позиционирования из-за которого вы теряете деньги и клиентов" },
        { name: "Павел Гусинский", role: "Квантовый трейдер и предприниматель", teaser: "Деньги для бизнеса: где их искать" },
        { name: "Алеся Аминова", role: "Предприниматель, основатель Fundacja Mental Health Institute и проекта Aminova Reset. 20+ лет в бизнесе", teaser: "Ментальное здоровье как бизнес-инструмент. Почему это влияет на деньги, решения и команду" },
      ],
    },
    atmosphere: { eyebrow: "Атмосфера", title: "Наша атмосфера", desc: "" },
    organizers: {
      eyebrow: "Команда",
      title: "Организаторы",
      list: [
        { name: "Лиола Ермолаева", role: "Маркетолог, собственница курортного апарта, создатель авторских туров по Европе", photo: "/events/bizcon-warszawa/speakers/Liola.jpeg" },
        { name: "Дина Завадская", role: "Маркетолог с опытом более 4 лет, владелица 2-ух онлайн бизнесов", photo: "/events/bizcon-warszawa/speakers/Dina.jpeg" },
      ],
    },
    pricing: {
      eyebrow: "Билеты",
      title: "Выберите формат участия",
      desc: "Пять вариантов — от стандартного билета до полноценного партнёрства с выступлением.",
      footer: "Оплата картой через защищённое соединение Stripe. После оплаты вы получите место в закрытом чате участников.",
      badges: { popular: "Популярный", premium: "Премиум", combo: "Комбо" },
      tickets: {
        standard: { name: "Стандарт", sub: "", cta: "Купить Стандарт", perks: [
          "Полный доступ к конференции",
          "Структурированные нетворкинг-сессии",
          "Доступ ко всей программе мероприятия",
        ]},
        mini_partner: { name: "Мини-Партнёр", sub: "Билет + Партнёрство", cta: "Стать Мини-Партнёром", perks: [
          "Всё, что входит в Стандарт",
          "Стол с визитками или флаерами вашего бизнеса",
          "Упоминание в официальных соцсетях конференции",
        ]},
        speaker: { name: "Билет Спикера", sub: "", cta: "Выступить со сцены", perks: [
          "Всё, что входит в Стандарт",
          "10-минутный open-mic слот на сцене (без слайдов)",
          "Питч себя, проекта или бизнеса с главной сцены",
          "Разрешение раздавать флаеры аудитории",
        ]},
        conference_partner: { name: "Партнёр Конференции", sub: "Премиум", cta: "Стать Партнёром", perks: [
          "Полный партнёрский статус с правом презентации",
          "30-минутное выступление с главной сцены",
          "Премиум-продвижение во всех соцсетях конференции",
        ]},
        afterparty: { name: "Afterparty", sub: "Дополнительный билет", cta: "На Afterparty", perks: [
          "Неформальный нетворкинг",
          "Расслабленная атмосфера с развлекательной программой",
          "Игра в «Мафию»",
        ]},
        bizcon_fuckup: { name: "BizCon + Fuckup Stand-up", sub: "Комбо-билет", cta: "Купить Комбо", perks: [
          "14:00–18:00 | BizCon — нетворкинг, инсайты, выступления экспертов",
          "18:00–… | Fuckup Stand-up — честные истории, уроки и общение в расслабленной атмосфере",
          "Новые возможности для партнёрств",
        ]},
        brunch_afterparty: { name: "Бранч со спикерами + Afterparty", sub: "Дополнительный билет", cta: "Купить Бранч", perks: [
          "Близкое общение со спикерами / обмен контактами",
          "Возможность презентовать себя",
          "Игра в «Мафию»",
          "Живой концерт",
        ]},
        brunch_speakers: { name: "Бранч со спикерами", sub: "Дополнительный билет", cta: "Купить Бранч", perks: [
          "Закрытый нетворкинг с интерактивными активностями",
          "Личное общение с каждым из спикеров",
          "Возможность найти новые контакты среди людей, ищущих партнёрства и инсайты",
        ]},
      },
    },
    partners: { eyebrow: "Партнёры", title: "Поддерживают мероприятие" },
    faq: {
      eyebrow: "FAQ",
      title: "Частые вопросы",
      items: [
        { q: "Где проходит конференция?", a: "Варшава, Польша. Точный адрес локации мы пришлём в Telegram после оплаты." },
        { q: "Можно ли вернуть билет?", a: "Возврат возможен до 7 дней до мероприятия согласно политике возврата." },
        { q: "Нужен ли дресс-код?", a: "Smart casual или business casual — комфортно и презентабельно." },
        { q: "Будут ли материалы?", a: "Да, фото и видео-репортаж раздаются всем участникам после мероприятия." },
      ],
    },
    footer: {
      brand: "Business Conference",
      sub: "21.06 · 14:00 · Варшава, Польша",
      copy: "© {year} Business Conference Warsaw. Все права защищены.",
      contact_location: "Варшава, Польша",
      contact_date: "21.06 · 14:00",
      contact_tg: "@bizconf_warsaw",
    },
  },

  en: {
    nav: {
      brand: "Business Conf · Warsaw",
    },
    hero: {
      date_chip: "21.06",
      date_sub: "14:00 · Warsaw, Poland",
      title1: "BUSINESS",
      title2: "CONFERENCE",
      desc: "Upgrade your network, personal brand, and business among like-minded professionals. One day that changes the trajectory of your next year.",
      cta_tickets: "Choose ticket",
      cta_program: "View program",
      stat1k: "100+", stat1v: "Attendees",
      stat2k: "9", stat2v: "Formats",
      stat3k: "1", stat3v: "Day you'll remember",
      stage_kicker: "Main stage",
      stage_title: "Insight flow",
    },
    program: {
      eyebrow: "Inside",
      title: "Conference Program",
      desc: "Nine program elements, built so every guest leaves with real contacts and insights.",
      items: [
        { title: "Keynotes by top speakers", text: "Deep talks by practitioners with real experience and case studies." },
        { title: "Gifts for every guest", text: "Welcome kit and surprises from event partners." },
        { title: "Signature networking", text: "Structured format for meeting people — no awkward pauses." },
        { title: "Exclusive community chat", text: "Access to a private chat for attendees after the conference." },
        { title: "Welcome drink & finger food", text: "A light reception in a relaxed atmosphere." },
        { title: "Interactive workshops", text: "Hands-on sessions — you leave with tools, not theory." },
        { title: "Premium photo zone", text: "Perfect shots for social media and your personal brand." },
        { title: "Professional photo/video", text: "Full coverage — content you can use for months." },
        { title: "Afterparty", text: "Informal networking and a Mafia game with attendees." },
      ],
    },
    speakers: {
      eyebrow: "Stage",
      title: "Conference Speakers",
      desc: "Six speakers — practitioners in business, marketing, investment and personal brand.",
      role_label: "Topic",
      list: [
        { name: "Viktor Bartak", role: "Owner of the #1 B2B SEO agency (UK Search Awards)", teaser: "Getting clients through SEO & AEO & GEO in 2026" },
        { name: "Renata Bergen", role: "Strategic advisor to owners and C-level | Business psychologist", teaser: "Psychology of stable income: online/offline" },
        { name: "Dina Zavadskaya", role: "Marketer with 4+ years experience, owner of 2 online businesses", teaser: "Promotion system in 2026" },
        { name: "Yulia Lasker", role: "Personal brand strategist | UN Red Ribbon Ambassador | MTV Award winner", teaser: "Positioning mistake that costs you money and clients" },
        { name: "Paweł Gusiński", role: "Quantitative trader and entrepreneur", teaser: "Money for business: where to find it" },
        { name: "Alesya Aminova", role: "Entrepreneur, founder of Fundacja Mental Health Institute and Aminova Reset. 20+ years in business", teaser: "Mental health as a business tool. Why it affects money, decisions and your team" },
      ],
    },
    atmosphere: { eyebrow: "Atmosphere", title: "Our atmosphere", desc: "" },
    organizers: {
      eyebrow: "Team",
      title: "Organizers",
      list: [
        { name: "Liola Ermolaeva", role: "Marketer | Resort Apartment Owner | Creator of Custom Tours in Europe", photo: "/events/bizcon-warszawa/speakers/Liola.jpeg" },
        { name: "Dina Zavadskaya", role: "Marketer with 4+ years experience, owner of 2 online businesses", photo: "/events/bizcon-warszawa/speakers/Dina.jpeg" },
      ],
    },
    pricing: {
      eyebrow: "Tickets",
      title: "Choose your participation format",
      desc: "Five options — from a standard ticket to a full partnership with a stage talk.",
      footer: "Card payment via Stripe’s secure connection. After payment you’ll get access to the private attendees chat.",
      badges: { popular: "Popular", premium: "Premium", combo: "Combo" },
      tickets: {
        standard: { name: "Standard", sub: "", cta: "Buy Standard", perks: [
          "Full access to the conference",
          "Structured networking sessions",
          "Access to the entire event program",
        ]},
        mini_partner: { name: "Mini Partner", sub: "Ticket + Partnership", cta: "Become a Mini Partner", perks: [
          "Everything in Standard",
          "Display table for your business cards or flyers",
          "Mention on the conference's official social channels",
        ]},
        speaker: { name: "Speaker Ticket", sub: "", cta: "Speak on stage", perks: [
          "Everything in Standard",
          "10-minute open-mic slot on stage (no slides)",
          "Pitch yourself, your project or business from the main stage",
          "Permission to distribute flyers",
        ]},
        conference_partner: { name: "Conference Partner", sub: "Premium", cta: "Become a Partner", perks: [
          "Full partner status with slide presentation rights",
          "30-minute keynote from the main stage",
          "Premium promotion across all conference social channels",
        ]},
        afterparty: { name: "Afterparty", sub: "Add-on ticket", cta: "Join Afterparty", perks: [
          "Informal networking",
          "Relaxed atmosphere with an entertainment program",
          "“Mafia” game session",
        ]},
        bizcon_fuckup: { name: "BizCon + Fuckup Stand-up", sub: "Combo ticket", cta: "Buy Combo", perks: [
          "2:00 PM – 6:00 PM | BizCon — networking, industry insights, expert talks",
          "6:00 PM – Late | Fuckup Stand-up — honest stories, unexpected lessons, relaxed networking",
          "New partnership opportunities",
        ]},
        brunch_afterparty: { name: "Brunch with Speakers + Afterparty", sub: "Add-on ticket", cta: "Buy Brunch", perks: [
          "Close conversation with speakers / contact exchange",
          "Opportunity to present yourself",
          "Mafia game",
          "Live concert",
        ]},
        brunch_speakers: { name: "Brunch with Speakers", sub: "Add-on ticket", cta: "Buy Brunch", perks: [
          "Closed networking with interactive activities",
          "Personal communication with each of the speakers",
          "An opportunity to find new contacts among people who want to find partnerships and insights",
        ]},
      },
    },
    partners: { eyebrow: "Partners", title: "Event sponsors" },
    faq: {
      eyebrow: "FAQ",
      title: "Frequently asked",
      items: [
        { q: "Where is the conference held?", a: "Warsaw, Poland. We send the exact venue address via Telegram after payment." },
        { q: "Can I get a refund?", a: "Refunds are possible up to 7 days before the event according to the refund policy." },
        { q: "Is there a dress code?", a: "Smart casual or business casual — comfortable and presentable." },
        { q: "Will materials be available?", a: "Yes, photo and video coverage is shared with all attendees after the event." },
      ],
    },
    footer: {
      brand: "Business Conference",
      sub: "21.06 · 14:00 · Warsaw, Poland",
      copy: "© {year} Business Conference Warsaw. All rights reserved.",
      contact_location: "Warsaw, Poland",
      contact_date: "21.06 · 14:00",
      contact_tg: "@bizconf_warsaw",
    },
  },

  pl: {
    nav: {
      brand: "Business Conf · Warszawa",
    },
    hero: {
      date_chip: "21.06",
      date_sub: "14:00 · Warszawa, Polska",
      title1: "BUSINESS",
      title2: "CONFERENCE",
      desc: "Rozwiń swój networking, markę osobistą i biznes w gronie podobnie myślących profesjonalistów. Jeden dzień, który zmieni trajektorię Twojego kolejnego roku.",
      cta_tickets: "Wybierz bilet",
      cta_program: "Program dnia",
      stat1k: "100+", stat1v: "Uczestników",
      stat2k: "9", stat2v: "Formatów",
      stat3k: "1", stat3v: "Dzień, który zapamiętasz",
      stage_kicker: "Główna scena",
      stage_title: "Strumień inspiracji",
    },
    program: {
      eyebrow: "W programie",
      title: "Program konferencji",
      desc: "Dziewięć elementów programu — tak ułożonych, by każdy uczestnik wyszedł z realnymi kontaktami i inspiracjami.",
      items: [
        { title: "Wystąpienia topowych prelegentów", text: "Głębokie prelekcje praktyków z doświadczeniem i konkretami." },
        { title: "Prezenty dla każdego gościa", text: "Welcome-pakiet i niespodzianki od partnerów wydarzenia." },
        { title: "Autorski networking", text: "Ustrukturyzowany format poznawania ludzi — bez niezręcznych przerw." },
        { title: "Zamknięta społeczność na czacie", text: "Dostęp do prywatnego czatu uczestników po konferencji." },
        { title: "Welcome drink i finger food", text: "Lekki bufet w przyjemnej atmosferze." },
        { title: "Interaktywne warsztaty", text: "Praktyczne sesje — wynosisz narzędzia, nie teorię." },
        { title: "Premium strefa foto", text: "Idealne kadry do social mediów i marki osobistej." },
        { title: "Profesjonalne foto i wideo", text: "Pełna realizacja — materiały na Twój content." },
        { title: "Afterparty", text: "Nieformalny networking i partyjka „Mafii” z uczestnikami." },
      ],
    },
    speakers: {
      eyebrow: "Scena",
      title: "Prelegenci konferencji",
      desc: "Sześcioro prelegentów — praktyków z biznesu, marketingu, inwestycji i marki osobistej.",
      role_label: "Temat",
      list: [
        { name: "Viktor Bartak", role: "Właściciel agencji SEO nr 1 w B2B wg UK Search Awards", teaser: "Pozyskiwanie klientów przez SEO & AEO & GEO w 2026" },
        { name: "Renata Bergen", role: "Doradca strategiczny właścicieli i C-level | Psycholog biznesu", teaser: "Psychologia stabilnych dochodów: online/offline" },
        { name: "Dina Zavadskaya", role: "Marketerka z 4+ letnim doświadczeniem, właścicielka 2 biznesów online", teaser: "System promocji w 2026 roku" },
        { name: "Yulia Lasker", role: "Strateg marki osobistej | Ambasadorka UN Red Ribbon | Laureatka MTV", teaser: "Błąd pozycjonowania, przez który tracisz pieniądze i klientów" },
        { name: "Paweł Gusiński", role: "Trader kwantowy i przedsiębiorca", teaser: "Pieniądze na biznes: gdzie ich szukać" },
        { name: "Alesya Aminova", role: "Przedsiębiorczyni, założycielka Fundacji Mental Health Institute i projektu Aminova Reset. 20+ lat w biznesie", teaser: "Zdrowie psychiczne jako narzędzie biznesowe. Dlaczego wpływa na pieniądze, decyzje i zespół" },
      ],
    },
    atmosphere: { eyebrow: "Atmosfera", title: "Nasza atmosfera", desc: "" },
    organizers: {
      eyebrow: "Zespół",
      title: "Organizatorzy",
      list: [
        { name: "Liola Ermolaeva", role: "Marketerka | Właścicielka apartamentu wakacyjnego | Twórczyni autorskich wycieczek po Europie", photo: "/events/bizcon-warszawa/speakers/Liola.jpeg" },
        { name: "Dina Zavadskaya", role: "Marketerka z 4+ letnim doświadczeniem, właścicielka 2 biznesów online", photo: "/events/bizcon-warszawa/speakers/Dina.jpeg" },
      ],
    },
    pricing: {
      eyebrow: "Bilety",
      title: "Wybierz format uczestnictwa",
      desc: "Pięć opcji — od standardowego biletu po pełne partnerstwo z prelekcją.",
      footer: "Płatność kartą przez bezpieczne połączenie Stripe. Po opłaceniu otrzymasz dostęp do zamkniętego czatu uczestników.",
      badges: { popular: "Popularny", premium: "Premium", combo: "Kombo" },
      tickets: {
        standard: { name: "Standard", sub: "", cta: "Kup Standard", perks: [
          "Pełny dostęp do konferencji",
          "Ustrukturyzowane sesje networkingowe",
          "Dostęp do całego programu wydarzenia",
        ]},
        mini_partner: { name: "Mini Partner", sub: "Bilet + Partnerstwo", cta: "Zostań Mini Partnerem", perks: [
          "Wszystko, co w Standard",
          "Stoisko z wizytówkami lub ulotkami Twojego biznesu",
          "Wzmianka w oficjalnych social mediach konferencji",
        ]},
        speaker: { name: "Bilet Prelegenta", sub: "", cta: "Wystąp na scenie", perks: [
          "Wszystko, co w Standard",
          "10-minutowy slot open-mic na scenie (bez slajdów)",
          "Pitch siebie, projektu lub biznesu z głównej sceny",
          "Zgoda na rozdawanie ulotek publiczności",
        ]},
        conference_partner: { name: "Partner Konferencji", sub: "Premium", cta: "Zostań Partnerem", perks: [
          "Pełny status partnera z prawem do prezentacji slajdów",
          "30-minutowa prelekcja z głównej sceny",
          "Premium-promocja we wszystkich social mediach konferencji",
        ]},
        afterparty: { name: "Afterparty", sub: "Bilet dodatkowy", cta: "Idź na Afterparty", perks: [
          "Nieformalny networking",
          "Luźna atmosfera i program rozrywkowy",
          "Sesja gry w „Mafię”",
        ]},
        bizcon_fuckup: { name: "BizCon + Fuckup Stand-up", sub: "Bilet kombo", cta: "Kup Kombo", perks: [
          "14:00–18:00 | BizCon — networking, inspiracje branżowe, wystąpienia ekspertów",
          "18:00–… | Fuckup Stand-up — szczere historie, niespodziewane lekcje, networking w luźnej atmosferze",
          "Nowe możliwości partnerskie",
        ]},
        brunch_afterparty: { name: "Brunch ze speakerami + Afterparty", sub: "Bilet dodatkowy", cta: "Kup Brunch", perks: [
          "Bliska rozmowa ze speakerami / wymiana kontaktów",
          "Możliwość zaprezentowania się",
          "Gra w \u201EMafi\u0119\u201D",
          "Koncert na żywo",
        ]},
        brunch_speakers: { name: "Brunch ze speakerami", sub: "Bilet dodatkowy", cta: "Kup Brunch", perks: [
          "Zamknięty networking z interaktywnymi aktywnościami",
          "Osobista rozmowa z każdym ze speakerów",
          "Możliwość znalezienia nowych kontaktów wśród osób szukających partnerstw i inspiracji",
        ]},
      },
    },
    partners: { eyebrow: "Partnerzy", title: "Wspierają wydarzenie" },
    faq: {
      eyebrow: "FAQ",
      title: "Najczęstsze pytania",
      items: [
        { q: "Gdzie odbywa się konferencja?", a: "Warszawa, Polska. Dokładny adres lokalizacji przyślemy w Telegramie po opłaceniu." },
        { q: "Czy mogę zwrócić bilet?", a: "Zwrot jest możliwy do 7 dni przed wydarzeniem zgodnie z polityką zwrotów." },
        { q: "Czy obowiązuje dress code?", a: "Smart casual lub business casual — wygodnie i reprezentacyjnie." },
        { q: "Czy będą materiały?", a: "Tak, foto i wideo-relacja trafia do wszystkich uczestników po wydarzeniu." },
      ],
    },
    footer: {
      brand: "Business Conference",
      sub: "21.06 · 14:00 · Warszawa, Polska",
      copy: "© {year} Business Conference Warsaw. Wszelkie prawa zastrzeżone.",
      contact_location: "Warszawa, Polska",
      contact_date: "21.06 · 14:00",
      contact_tg: "@bizconf_warsaw",
    },
  },
};

export default EVENT_TRANSLATIONS;
